import React from "react";
import { totalAmount } from "../../utils/amount";
import { useGlobalContext } from "../../hooks/context";
import DeleteIcon from "../../icon/DeleteIcon";

const TotalAmount = () => {
  const { selectedItems, deleteSelectedItem } = useGlobalContext();

  const deleteSelectedItemHandler = (id) => {
    deleteSelectedItem(id);
  };

  const amount = totalAmount(selectedItems);

  return (
    selectedItems?.length > 0 && (
      <div className="w-96 h-56 p-10 bg-custom-yellow-400 absolute right-0 top-[35%] kmd:top-[55%] z-50  rounded-l-[10%]">
        <div className="mb-8 flex justify-between items-center">
          <h5 className="text-4xl font-bold uppercase">Total</h5>
          <h5 className="text-4xl font-bold uppercase">
            $ {amount.toFixed(2)}
          </h5>
        </div>
        {selectedItems?.map((item, i) => (
          <div key={i} className="flex justify-end">
            <div className="flex items-center justify-between gap-x-5">
              <p className="text-sm font-medium">
                ({i + 1}) {item.name}
              </p>
              <p className="text-sm font-medium">$ {item.price}</p>
              <span onClick={() => deleteSelectedItemHandler(item.id)}>
                <DeleteIcon />
              </span>
            </div>
          </div>
        ))}
      </div>
    )
  );
};

export default TotalAmount;
